module.exports = __webpack_public_path__ + "static/media/grainger.b379f0b4.svg";